module.exports = __webpack_public_path__ + "static/media/gdpr-for-marketing-cover-de.bd6600b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ebook/gdpr-for-marketing-cover-de.png
// module id = 554
// module chunks = 0